import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=36b9899c&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=36b9899c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9899c",
  null
  
)

/* custom blocks */
import block0 from "../locales/index.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Frandyhoulahan%2Fprojects%2F%40scbd%2Fecosystem%2Fpackages%2Faction-search%2Fsrc%2Fcomponents%2FFeedback.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports